module.exports = __webpack_public_path__ + "static/media/diandongche.31574cf.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mp3/diandongche.mp3
// module id = nc5q
// module chunks = 208